export const inventory_child = [
  {
    "id": 2438,
    "name": "数据概况",
    "component": "apps/weishop/application/inventory/overview.vue",
    "path": "/weishop/application/inventory/overview",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251213/202512131607582351.svg",
    "layout": "1",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": []
  },
  {
    "id": 2439,
    "name": "采购管理",
    "component": "Layout",
    "path": "",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251213/202512131624554473.svg",
    "layout": "1",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": [
      {
        "id": 2440,
        "name": "采购总览",
        "component": "apps/weishop/application/inventory/purchase/overview.vue",
        "path": "/weishop/application/inventory/purchase/overview",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2441,
        "name": "添加采购员",
        "component": "apps/weishop/application/inventory/purchase/user_add.vue",
        "path": "/weishop/application/inventory/purchase/user_add",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2442,
        "name": "新增任务",
        "component": "apps/weishop/application/inventory/purchase/list_add.vue",
        "path": "/weishop/application/inventory/purchase/list_add",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2443,
        "name": "采购单编辑",
        "component": "apps/weishop/application/inventory/purchase/accounts_edit.vue",
        "path": "/weishop/application/inventory/purchase/accounts_edit",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2444,
        "name": "采购单查看",
        "component": "apps/weishop/application/inventory/purchase/accounts_look.vue",
        "path": "/weishop/application/inventory/purchase/accounts_look",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2445,
        "name": "采购单录单",
        "component": "apps/weishop/application/inventory/purchase/accounts_lu.vue",
        "path": "/weishop/application/inventory/purchase/accounts_lu",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2446,
        "name": "采购单入库单",
        "component": "apps/weishop/application/inventory/purchase/accounts_ru.vue",
        "path": "/weishop/application/inventory/purchase/accounts_ru",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2447,
        "name": "采购任务",
        "component": "apps/weishop/application/inventory/purchase/list.vue",
        "path": "/weishop/application/inventory/purchase/list",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2448,
        "name": "添加采购任务",
        "component": "apps/weishop/application/inventory/purchase/add.vue",
        "path": "/weishop/application/inventory/purchase/add",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2449,
        "name": "采购单",
        "component": "apps/weishop/application/inventory/purchase/accounts.vue",
        "path": "/weishop/application/inventory/purchase/accounts",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2450,
        "name": "缺货商品",
        "component": "apps/weishop/application/inventory/purchase/little.vue",
        "path": "/weishop/application/inventory/purchase/little",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2451,
        "name": "商品详情",
        "component": "apps/weishop/application/inventory/purchase/good_details.vue",
        "path": "/weishop/application/inventory/purchase/good_details",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2452,
        "name": "采购退货",
        "component": "apps/weishop/application/inventory/purchase/refund.vue",
        "path": "/weishop/application/inventory/purchase/refund",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2453,
        "name": "采购员",
        "component": "apps/weishop/application/inventory/purchase/user.vue",
        "path": "/weishop/application/inventory/purchase/user",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2516,
        "name": "创建采购单",
        "component": "apps/weishop/application/inventory/purchase/refund_add.vue",
        "path": "/weishop/application/inventory/purchase/refund_add",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2517,
        "name": "采购单审核",
        "component": "apps/weishop/application/inventory/purchase/refund_shen.vue",
        "path": "/weishop/application/inventory/purchase/refund_shen",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2518,
        "name": "采购退货查看",
        "component": "apps/weishop/application/inventory/purchase/refund_look.vue",
        "path": "/weishop/application/inventory/purchase/refund_look",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      }
    ]
  },
  {
    "id": 2454,
    "name": "仓库管理",
    "component": "Layout",
    "path": "",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251213/202512131159032378.svg",
    "layout": "1",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": [
      {
        "id": 2455,
        "name": "库房预警",
        "component": "apps/weishop/application/inventory/godown/warning.vue",
        "path": "/weishop/application/inventory/godown/warning",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2456,
        "name": "入库管理",
        "component": "apps/weishop/application/inventory/godown/store.vue",
        "path": "/weishop/application/inventory/godown/store",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2457,
        "name": "订单出库",
        "component": "apps/weishop/application/inventory/godown/order.vue",
        "path": "/weishop/application/inventory/godown/order",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2458,
        "name": "出库管理",
        "component": "apps/weishop/application/inventory/godown/outbound.vue",
        "path": "/weishop/application/inventory/godown/outbound",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2459,
        "name": "报损报溢",
        "component": "apps/weishop/application/inventory/godown/loss.vue",
        "path": "/weishop/application/inventory/godown/loss",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2460,
        "name": "库存盘点",
        "component": "apps/weishop/application/inventory/godown/inventory.vue",
        "path": "/weishop/application/inventory/godown/inventory",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2461,
        "name": "货架商品",
        "component": "apps/weishop/application/inventory/godown/now.vue",
        "path": "/weishop/application/inventory/godown/now",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2462,
        "name": "商品台账",
        "component": "apps/weishop/application/inventory/godown/good.vue",
        "path": "/weishop/application/inventory/godown/good",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2463,
        "name": "仓库人员",
        "component": "apps/weishop/application/inventory/godown/user.vue",
        "path": "/weishop/application/inventory/godown/user",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2540,
        "name": "仓库人员编辑",
        "component": "apps/weishop/application/inventory/godown/user_edit.vue",
        "path": "/weishop/application/inventory/godown/user_edit",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2464,
        "name": "期初库存",
        "component": "apps/weishop/application/inventory/godown/beginning.vue",
        "path": "/weishop/application/inventory/godown/beginning",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2465,
        "name": "库位管理",
        "component": "apps/weishop/application/inventory/godown/wei.vue",
        "path": "/weishop/application/inventory/godown/wei",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2466,
        "name": "库房设置",
        "component": "apps/weishop/application/inventory/godown/set.vue",
        "path": "/weishop/application/inventory/godown/set",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2467,
        "name": "入库审核",
        "component": "apps/weishop/application/inventory/godown/store_shen.vue",
        "path": "/weishop/application/inventory/godown/store_shen",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2468,
        "name": "商品库存",
        "component": "apps/weishop/application/inventory/godown/now_ku.vue",
        "path": "/weishop/application/inventory/godown/now_ku",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2469,
        "name": "创建入库单",
        "component": "apps/weishop/application/inventory/godown/store_add.vue",
        "path": "/weishop/application/inventory/godown/store_add",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2519,
        "name": "新增出库单",
        "component": "apps/weishop/application/inventory/godown/outbound_add.vue",
        "path": "/weishop/application/inventory/godown/outbound_add",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2520,
        "name": "审核出库单",
        "component": "apps/weishop/application/inventory/godown/outbound_shen.vue",
        "path": "/weishop/application/inventory/godown/outbound_shen",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2521,
        "name": "创建库存盘点",
        "component": "apps/weishop/application/inventory/godown/inventory_add.vue",
        "path": "/weishop/application/inventory/godown/inventory_add",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2522,
        "name": "审核库存盘点",
        "component": "apps/weishop/application/inventory/godown/inventory_shen.vue",
        "path": "/weishop/application/inventory/godown/inventory_shen",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2523,
        "name": "创建报损报溢单",
        "component": "apps/weishop/application/inventory/godown/loss_add.vue",
        "path": "/weishop/application/inventory/godown/loss_add",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2524,
        "name": "审核报损报溢单",
        "component": "apps/weishop/application/inventory/godown/loss_shen.vue",
        "path": "/weishop/application/inventory/godown/loss_shen",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      }
    ]
  },
  {
    "id": 2470,
    "name": "分拣管理",
    "component": "Layout",
    "path": "",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251213/202512131625109822.svg",
    "layout": "1",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": [
      {
        "id": 2471,
        "name": "分拣概况",
        "component": "apps/weishop/application/inventory/sorting/overview.vue",
        "path": "/weishop/application/inventory/sorting/overview",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2472,
        "name": "商品分拣",
        "component": "apps/weishop/application/inventory/sorting/good.vue",
        "path": "/weishop/application/inventory/sorting/good",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2473,
        "name": "订单分拣",
        "component": "apps/weishop/application/inventory/sorting/order.vue",
        "path": "/weishop/application/inventory/sorting/order",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2474,
        "name": "会员分拣",
        "component": "apps/weishop/application/inventory/sorting/user.vue",
        "path": "/weishop/application/inventory/sorting/user",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2475,
        "name": "分拣差异",
        "component": "apps/weishop/application/inventory/sorting/divide.vue",
        "path": "/weishop/application/inventory/sorting/divide",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2476,
        "name": "分拣权限",
        "component": "apps/weishop/application/inventory/sorting/power.vue",
        "path": "/weishop/application/inventory/sorting/power",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2477,
        "name": "预分拣",
        "component": "apps/weishop/application/inventory/sorting/appointment.vue",
        "path": "/weishop/application/inventory/sorting/appointment",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2478,
        "name": "绩效设置",
        "component": "apps/weishop/application/inventory/sorting/setmerits.vue",
        "path": "/weishop/application/inventory/sorting/setmerits",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2479,
        "name": "阈值设置",
        "component": "apps/weishop/application/inventory/sorting/setthreshold.vue",
        "path": "/weishop/application/inventory/sorting/setthreshold",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2480,
        "name": "分拣设置",
        "component": "apps/weishop/application/inventory/sorting/setsorting.vue",
        "path": "/weishop/application/inventory/sorting/setsorting",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      }
    ]
  },
  {
    "id": 2481,
    "name": "财务管理",
    "component": "Layout",
    "path": "",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251213/202512131625544531.svg",
    "layout": "1",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": [
      {
        "id": 2482,
        "name": "账户管理",
        "component": "apps/weishop/application/inventory/finance/account.vue",
        "path": "/weishop/application/inventory/finance/account",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2483,
        "name": "账期欠款",
        "component": "apps/weishop/application/inventory/finance/debt.vue",
        "path": "/weishop/application/inventory/finance/debt",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2484,
        "name": "会员差额",
        "component": "apps/weishop/application/inventory/finance/user.vue",
        "path": "/weishop/application/inventory/finance/user",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2485,
        "name": "采购总账",
        "component": "apps/weishop/application/inventory/finance/buy.vue",
        "path": "/weishop/application/inventory/finance/buy",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2486,
        "name": "采购账单",
        "component": "apps/weishop/application/inventory/finance/bill.vue",
        "path": "/weishop/application/inventory/finance/bill",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2487,
        "name": "采购结算单",
        "component": "apps/weishop/application/inventory/finance/settlement.vue",
        "path": "/weishop/application/inventory/finance/settlement",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2488,
        "name": "销售账单",
        "component": "apps/weishop/application/inventory/finance/sales.vue",
        "path": "/weishop/application/inventory/finance/sales",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2489,
        "name": "销售结算单",
        "component": "apps/weishop/application/inventory/finance/xsales.vue",
        "path": "/weishop/application/inventory/finance/xsales",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2490,
        "name": "货值报表",
        "component": "apps/weishop/application/inventory/finance/good.vue",
        "path": "/weishop/application/inventory/finance/good",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2491,
        "name": "供应商结算",
        "component": "apps/weishop/application/inventory/finance/supplier.vue",
        "path": "/weishop/application/inventory/finance/supplier",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      }
    ]
  },
  {
    "id": 2492,
    "name": "报表管理",
    "component": "Layout",
    "path": "",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251213/202512131626014468.svg",
    "layout": "1",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": [
      {
        "id": 2493,
        "name": "销售报表",
        "component": "apps/weishop/application/inventory/report/sales.vue",
        "path": "/weishop/application/inventory/report/sales",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2494,
        "name": "配送绩效",
        "component": "apps/weishop/application/inventory/report/delivery.vue",
        "path": "/weishop/application/inventory/report/delivery",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2495,
        "name": "分拣分析",
        "component": "apps/weishop/application/inventory/report/sorting.vue",
        "path": "/weishop/application/inventory/report/sorting",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2496,
        "name": "分拣绩效",
        "component": "apps/weishop/application/inventory/report/merits.vue",
        "path": "/weishop/application/inventory/report/merits",
        "icon": "",
        "layout": "2",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2497,
        "name": "会员分析",
        "component": "apps/weishop/application/inventory/report/user.vue",
        "path": "/weishop/application/inventory/report/user",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2498,
        "name": "利润报表",
        "component": "apps/weishop/application/inventory/report/profit.vue",
        "path": "/weishop/application/inventory/report/profit",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      }
    ]
  },
  {
    "id": 2499,
    "name": "发票管理",
    "component": "Layout",
    "path": "",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251213/202512131626083919.svg",
    "layout": "1",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": [
      {
        "id": 2500,
        "name": "未申请",
        "component": "apps/weishop/application/inventory/invoice/noapplied.vue",
        "path": "/weishop/application/inventory/invoice/noapplied",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2501,
        "name": "已申请",
        "component": "apps/weishop/application/inventory/invoice/applied.vue",
        "path": "/weishop/application/inventory/invoice/applied",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      },
      {
        "id": 2502,
        "name": "已开票",
        "component": "apps/weishop/application/inventory/invoice/invoiced.vue",
        "path": "/weishop/application/inventory/invoice/invoiced",
        "icon": "",
        "layout": "1",
        "router_name": "weishoperp",
        "vue_name": "",
        "app_level": 0,
        "plugin": null,
        "is_plugin": 0,
        "_child": []
      }
    ]
  },
  {
    "id": 2503,
    "name": "单据管理",
    "component": "apps/weishop/application/inventory/receipt.vue",
    "path": "/weishop/application/inventory/receipt",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251204/202512040911256573.svg",
    "layout": "2",
    "router_name": "weishopero",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": []
  },
  {
    "id": 2505,
    "name": "基础设置",
    "component": "apps/weishop/application/inventory/set.vue",
    "path": "/weishop/application/inventory/set",
    "icon": "https://shop.yibohong.com/storage/upload/file/20251204/202512040909005563.svg",
    "layout": "1",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": []
  },
  {
    "id": 2509,
    "name": "规格映射",
    "component": "apps/weishop/application/inventory/spec.vue",
    "path": "/weishop/application/inventory/spec",
    "icon": "",
    "layout": "2",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": []
  },
  {
    "id": 2507,
    "name": "库存查询",
    "component": "apps/weishop/application/inventory/query.vue",
    "path": "/weishop/application/inventory/query",
    "icon": "",
    "layout": "2",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": []
  },
  {
    "id": 2508,
    "name": "商品调价",
    "component": "apps/weishop/application/inventory/adjust.vue",
    "path": "/weishop/application/inventory/adjust",
    "icon": "",
    "layout": "2",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": []
  },
  {
    "id": 2510,
    "name": "进出明细",
    "component": "apps/weishop/application/inventory/stockdetail.vue",
    "path": "/weishop/application/inventory/stockdetail",
    "icon": "",
    "layout": "2",
    "router_name": "weishoperp",
    "vue_name": "",
    "app_level": 0,
    "plugin": null,
    "is_plugin": 0,
    "_child": []
  }
];